export const centerReviewKeys = {
    all: ['centerReview'] as const,
    dashboard: (centerId: string) => [...centerReviewKeys.all, 'dashboard', centerId] as const,
    coachDashboard: (coachId: string, centerId?: string) =>
        [...centerReviewKeys.all, 'coachDashboard', coachId, centerId || 'legacy'] as const,
    memberReviewDetail: (reviewId: string) => [...centerReviewKeys.all, 'memberReviewDetail', reviewId] as const,
    memberReviewList: (centerId: string) => [...centerReviewKeys.all, 'memberReviewList', centerId] as const,
};
